import * as l from "react";
const c = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" }),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M11.09 21.229c-.665.201-1.625.614-2.009.845-.124.08-.112.171.08.513.135.222.27.413.293.413.034 0 .406-.15.824-.342.417-.181.95-.42 1.196-.463.188-.033.359-.064.465-.103.043.093.016.041.094.186.112.209.042.204.236.261.203.06.706-.183.706-.183.587-.181.914-.201 3.025-.201 2.11 0 2.438.02 3.024.211 0 0 .473.143.534.16.06.018.092.031.155.018.058-.013.12-.092.146-.14 0 0 .13-.278.163-.375.112.048.317.11.515.166.237.07.767.282 1.185.463.418.191.79.342.824.342.022 0 .158-.191.293-.413.271-.473.294-.432-.688-.885-1.31-.604-2.619-.876-2.743-.584-.022.056-.042.088-.073.16-.13-.027-.474-.1-.818-.15-1.061-.17-3.973-.17-5.034 0-.344.05-.577.135-.771.183-.11-.197-.088-.119-.11-.174-.09-.201-.688-.17-1.512.092z",
      fill: "#DFDFDF"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M12.05 8.793c-.023.328.045.56.223.736.08.084.148.184.148.184s-.091.1-.167.176a.876.876 0 00-.25.644c0 .248.072.42.265.643 0 0 .163.082.16.184-.005.102-.175.204-.175.204-.349.408-.337.876.027 1.264l.155.172H19.572l.175-.196c.337-.38.337-.792.003-1.228 0 0-.168-.12-.17-.22-.003-.1.159-.2.159-.2.349-.44.341-.843-.019-1.267-.163-.188-.167-.224-.038-.312.209-.148.337-.648.243-.952-.14-.456-.743-.76-1.11-.56a2.448 2.448 0 00-.308.22c-.102.088-.197.156-.216.156-.015 0-.106-.072-.2-.16-.368-.332-.81-.372-1.178.004 0 0-.053.201-.13.208-.077.007-.186-.18-.186-.18-.375-.372-.845-.356-1.228.036 0 0-.053.164-.14.144-.086-.02-.158-.212-.158-.212-.223-.216-.365-.212-.623-.216-.148-.002-.417.034-.579.155-.162.122-.134.267-.171.257-.094-.025-.197-.176-.197-.176-.364-.328-.656-.384-1.008-.188a.798.798 0 00-.444.68z",
      fill: "#171796"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M12.285 14.492s.145.07.14.161c-.005.091-.16.181-.16.181a1.49 1.49 0 00-.211.311.912.912 0 00.208.941c.144.146.148.205.011.378-.06.075-.132.181-.159.236-.284.56.14 1.26.77 1.26.25 0 .44-.083.61-.272.137-.15.209-.153.33-.02.178.205.413.331.61.331.232 0 .376-.075.61-.307 0 0 .094-.182.179-.18.085 0 .163.184.163.184.352.394.709.406 1.183.032 0 0 .104-.152.193-.15.09.002.167.157.167.157.208.19.364.264.569.264.204 0 .356-.082.595-.326 0 0 .123-.186.197-.197.074-.012.151.141.151.141.292.272.451.359.664.359.22 0 .375-.075.595-.28.205-.193.315-.417.288-.602-.026-.2-.2-.567-.33-.693 0 0-.129-.011-.11-.11.02-.1.171-.2.171-.2.371-.454.375-.804.008-1.253 0 0-.154-.088-.152-.189.002-.1.16-.2.16-.2.355-.437.352-.843-.008-1.24L19.533 13l-3.548.004-3.548.004-.16.185c-.371.429-.367.866.008 1.299z",
      fill: "#D42E12"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.82 13.622c.172 0 .315.117.345.271l.006.06v.614l.734-.39a.337.337 0 01.453.135.328.328 0 01-.085.415l-.05.033-.617.327.616.328.05.032a.328.328 0 01.087.415.337.337 0 01-.454.135l-.734-.39v.684a.34.34 0 01-.35.331.345.345 0 01-.345-.271l-.005-.06v-.601l-.58.307a.337.337 0 01-.453-.135.328.328 0 01.086-.415l.05-.032.617-.328-.616-.327-.05-.033a.328.328 0 01-.087-.415.337.337 0 01.454-.135l.579.308v-.532a.34.34 0 01.35-.33zM14.422 13.622c.172 0 .315.117.345.271l.005.06v.614l.735-.39a.337.337 0 01.453.135.328.328 0 01-.086.415l-.05.033-.617.327.617.328.05.032a.328.328 0 01.086.415.337.337 0 01-.453.135l-.735-.39v.684a.34.34 0 01-.35.331.345.345 0 01-.344-.271l-.006-.06v-.601l-.579.307a.337.337 0 01-.453-.135.328.328 0 01.086-.415l.05-.032.617-.328-.617-.327-.05-.033a.328.328 0 01-.086-.415.337.337 0 01.453-.135l.58.308v-.532a.34.34 0 01.35-.33z",
      fill: "#E9D315"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M10.852 12.857h.15v.066c-.085-.002-.148-.064-.15-.066h0v.685l.002 1.598c.001 1.217.003 2.589.007 3.213a.396.396 0 00.1.303.745.745 0 00.101.09l.043.033.062.047.093-.118-.093.118c.09.07.243.127.42.172.185.048.418.09.686.122.535.063 1.217.087 1.94.03.305.003.53.063.7.146.173.083.3.194.407.31.054.058.102.117.15.175l.002.004c.046.055.094.113.142.164.099.103.225.201.404.201.18 0 .304-.099.4-.203.048-.052.094-.112.139-.169l.003-.004c.044-.057.089-.115.139-.172.1-.115.22-.225.382-.308.162-.082.376-.141.672-.144.819.013 1.516-.007 2.04-.056.262-.025.484-.057.658-.097.164-.038.311-.088.4-.165h0l.008-.006.023-.02c.019-.016.045-.04.072-.068a.681.681 0 00.159-.236.74.74 0 00.033-.324V6.85H10.852V12.857z",
      stroke: "#000",
      strokeWidth: 0.3
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M14.868 9.866c-.269.5-.28.724-.057 1.124.174.308.378.503.658.628.73.33 1.663.087 2.03-.529.227-.378.2-1.009-.049-1.284l-.068-.074-.064.218c-.091.31-.182.468-.363.634-.34.311-.81.381-1.293.19-.375-.151-.526-.36-.666-.94l-.034-.144-.094.177z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.478 3.5c0 .866-.623 1.5-1.5 1.5-.878 0-1.496-.634-1.496-1.5 0-.87.619-1.5 1.495-1.5.878 0 1.5.63 1.5 1.5zM6.523 4.952v-2.02l.893 2.02h.39l.872-2.02v2.02h.529V2.047h-.613L7.617 4.28l-.988-2.233H6v2.905h.523zm3.704 0l.332-.804h1.242l.333.804h.56l-1.247-2.905h-.528L9.672 4.952h.555zm.951-2.304l-.444 1.074h.888l-.444-1.074zm3.074 2.304v-1.16l1.178-1.745h-.58l-.857 1.301-.86-1.301h-.598l1.173 1.746v1.16h.544zm2.725-.392c-.57 0-.94-.444-.94-1.06 0-.615.37-1.06.94-1.06.571 0 .946.445.946 1.06 0 .616-.375 1.06-.945 1.06zm3.287-2.078v2.47h-.55v-2.47h-1.077v-.435h2.705v.435h-1.078zm3.021 2.47v-2.47h1.078v-.435h-2.705v.435h1.078v2.47h.55zM27 4.512v.44h-2.118V2.047h2.118v.435h-1.58v.767h1.432v.43H25.42v.833H27z",
      fill: "#FF2500"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.776 18.8s-.34-.67.52-1c.86-.33 1.28.1 1.66.501.378.4.337 1.609.337 1.609l-.936 1.497-2.872.593-1.144-.593L23 18.8l.1-2.558s.136-.98.136-1.183c0-.203.623-1.776.623-1.776l.59-.584 1.67-.888.785-.393.976-1.233-.108-.982-1.112 1.417h-.942l-.98.41-.397.373-.482.015-.189-.388.527-.845.795-.8-.366-.678.542-.247-.104-.373.6.373.454-.373.087-.343-1.037-.556s1.014-.425 1.492-.381c.477.044.928.606.928.606l1.367-.225s-.366.9-.247.9h.86l-.276 1.115h1.06l-.784.86.612.335-.93.632.93.626-.865.568.487.941.767-.466.431.584-.649 1.44-1.058.75-1.01.255-.987.257-.392.257-.244-.985-1.668 1.144-.866 1.793.255 1.63.61.834 1.127.403 1.47-.276.768-.935.184-.955s-.445-.648-.768-.594c-.323.054-.995.5-.995.5z",
      fill: "#DFDFDF",
      stroke: "#000",
      strokeWidth: 0.3
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M25.082 12.225l-.037.398c1.154.107 1.918.05 2.317-.2l.08-.056-.249-.313c-.243.194-.876.265-1.874.19l-.237-.02zM23.744 13.379l-.037.398c1.154.107 1.918.05 2.317-.199l.08-.056-.249-.313c-.243.193-.876.265-1.874.19l-.237-.02zM23.423 14.455l-.067.394c.68.115 1.107.062 1.25-.235l.03-.08-.384-.11c-.02.071-.236.113-.675.054l-.154-.023z",
      fill: "#000"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.75 9.5a.25.25 0 110-.5.25.25 0 010 .5z",
      fill: "#000"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.224 18.8s.34-.67-.52-1c-.86-.33-1.28.1-1.66.501-.378.4-.336 1.609-.336 1.609l.935 1.497L6.515 22l1.144-.593L9 18.8l-.1-2.558s-.136-.98-.136-1.183c0-.203-.623-1.776-.623-1.776l-.59-.584-1.67-.888-.785-.393-.976-1.233.108-.982L5.34 10.62h.942l.98.41.397.373.482.015.189-.388-.527-.845-.795-.8.366-.678-.542-.247.105-.373-.601.373-.454-.373-.086-.343 1.036-.556s-1.014-.425-1.492-.381c-.477.044-.928.606-.928.606l-1.367-.225s.366.9.247.9h-.86l.276 1.115h-1.06l.783.86-.61.335.93.632-.93.626.864.568-.487.941-.767-.466-.431.584.649 1.44 1.059.75 1.008.255.988.257.392.257.244-.985L7.008 16.4l.866 1.793-.255 1.63-.61.834-1.127.403-1.47-.276-.769-.935-.183-.955s.445-.648.768-.594c.323.054.996.5.996.5z",
      fill: "#DFDFDF",
      stroke: "#000",
      strokeWidth: 0.3
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M6.918 12.225l.037.398c-1.154.107-1.918.05-2.317-.2l-.08-.056.249-.313c.243.194.876.265 1.874.19l.237-.02zM8.256 13.379l.037.398c-1.155.107-1.918.05-2.317-.199l-.08-.056.249-.313c.243.193.876.265 1.874.19l.237-.02zM8.577 14.455l.067.394c-.68.115-1.107.062-1.25-.235l-.03-.08.384-.11c.02.071.236.113.675.054l.154-.023z",
      fill: "#000"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.25 9.5a.25.25 0 100-.5.25.25 0 000 .5z",
      fill: "#000"
    }
  )
), t = c;
export {
  t as default
};
